// src/AllComponents/Product.js
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BaseUrl from "./Baseurl/Api";
import "../global.css";
import heroImg from "../image/dharajbanner.jpg";

const Product = () => {
  const [products, setProducts] = useState([]);
  const [inventory, setInventory] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [search, setSearch] = useState("");
  const [sortBy, setSortBy] = useState("default");
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 8;
  const productImageBaseUrl = `${BaseUrl.defaults.baseURL}/productimage/`;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const productRes = await BaseUrl.get("/api/get_allproduct");
        const inventoryRes = await BaseUrl.get("/api/get_inventoryData");

        if (productRes.data.status === "success") setProducts(productRes.data.product);
        if (inventoryRes.data.status === "success") setInventory(inventoryRes.data.inventorydata);

        // 🔹 Use categoryname instead of categoryid
        const uniqueCategories = ["all", ...new Set(productRes.data.product.map(p => p.categoryname || "Uncategorized"))];
        setCategories(uniqueCategories);
      } catch (error) {
        console.error("API Error:", error);
      }
    };
    fetchData();
  }, []);

  const findInventory = (id) => inventory.find((inv) => inv.pid?.toString() === id?.toString()) || {};
  const formatPrice = (p) => (p ? `₹${Number(p).toFixed(2)}` : "₹0.00");

  let filteredProducts = [...products];

  // 🔹 Search filter
  if (search.trim() !== "") {
    filteredProducts = filteredProducts.filter(p =>
      p.productName.toLowerCase().includes(search.toLowerCase())
    );
  }

  // 🔹 Category filter using categoryname
  if (selectedCategory !== "all") {
    filteredProducts = filteredProducts.filter(p =>
      p.categoryname?.toLowerCase() === selectedCategory.toLowerCase()
    );
  }

  // 🔹 Sorting
  if (sortBy === "az") filteredProducts.sort((a,b) => a.productName.localeCompare(b.productName));
  if (sortBy === "za") filteredProducts.sort((a,b) => b.productName.localeCompare(a.productName));
  if (sortBy === "low-high") filteredProducts.sort((a,b) => (findInventory(a.id).price || 0) - (findInventory(b.id).price || 0));
  if (sortBy === "high-low") filteredProducts.sort((a,b) => (findInventory(b.id).price || 0) - (findInventory(a.id).price || 0));

  const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentProducts = filteredProducts.slice(indexOfFirst, indexOfLast);

  return (
    <>
      {/* Hero Banner */}
      <div className="hero-container">
        <img src={heroImg} alt="Hero Banner" className="hero-img" />
      </div>

      {/* CSS */}
      <style>{`
        /* Hero */
        .hero-container { width: 100%; height: 380px; overflow: hidden; margin-bottom: 40px; border-radius: 0 0 25px 25px; }
        .hero-img { width: 100%; height: 100%; object-fit: cover; }

        /* Filters */
        .filter-bar input, .filter-bar select { height: 50px; font-size: 1.1rem; border-radius: 12px; }

        /* Product Grid */
        .product-grid {
          display: grid;
          gap: 25px;
          padding: 0 10px 60px 10px;
          grid-template-columns: 1fr;
        }
        @media (min-width: 576px) { .product-grid { grid-template-columns: repeat(2, 1fr); } }
        @media (min-width: 768px) { .product-grid { grid-template-columns: repeat(3, 1fr); } }
        @media (min-width: 992px) { .product-grid { grid-template-columns: repeat(4, 1fr); } }

        /* Product Card */
        .product-card { background: #fff; border-radius: 20px; overflow: hidden; box-shadow: 0 4px 20px rgba(0,0,0,0.08); position: relative; transition: 0.35s ease; width: 100%; }
        .product-card:hover { transform: translateY(-10px); box-shadow: 0 12px 32px rgba(0,0,0,0.15); }

        .product-card-img { width: 100%; aspect-ratio: 1/1.1; position: relative; overflow: hidden; }
        .product-card-img img { width: 100%; height: 100%; object-fit: cover; transition: 0.4s ease-in-out; }
        .hover-img { position: absolute; inset: 0; opacity: 0; }
        .product-card:hover .hover-img { opacity: 1; transform: scale(1.04); }
        .product-card:hover .main-img { opacity: 0; transform: scale(1.04); }

        /* Tags */
        .discount-tag, .bestseller-tag { position: absolute; top: 12px; padding: 6px 14px; font-size: 13px; font-weight: 700; border-radius: 50px; color: #fff; z-index: 4; }
        .discount-tag { right: 12px; background: #e63946; }
        .bestseller-tag { left: 12px; background: #1e5631; }

        /* Card Info */
        .product-card-title { font-size: 1.4rem; font-weight: 700; margin: 15px 0 5px; text-align: center; }
        .product-card-price { text-align: center; margin-bottom: 8px; }
        .product-card-price del { color: #888; margin-right: 6px; }
        .product-card-price ins { color: #1e5631; font-weight: 700; font-size: 1.4rem; }
        .product-rating { text-align: center; color: #ffb400; font-size: 1.4rem; margin-bottom: 15px; }

        /* Add to Cart Buttons */
        .card-atc-bar { position: absolute; bottom: 12px; left: 12px; right: 12px; display: flex; gap: 10px; opacity: 0; transform: translateY(15px); transition: all 0.3s ease; }
        .product-card:hover .card-atc-bar { opacity: 1; transform: translateY(0); }
        .card-btn { flex: 1; height: 50px; border-radius: 14px; border: none; font-weight: 600; font-size: 1rem; cursor: pointer; padding: 0 20px; background: #189f45ff; color: #fff; }
        .card-btn:hover { background: #306e45ff; }
        .buy-btn { background: #f1ff76ff; }
        .buy-btn:hover { background: #e7ff52ff; }

        /* Pagination */
        .pagination { display: flex; justify-content: center; gap: 10px; margin-bottom: 40px; }
        .page-btn { padding: 10px 20px; border-radius: 10px; background: #1e5631; color: #fff; border: none; font-weight: 700; cursor: pointer; }
        .disabled-btn { opacity: 0.4; cursor: not-allowed; }
      `}</style>

      <div className="container">
        {/* Filter Bar */}
        <div className="filter-bar mb-4 p-3 rounded shadow-sm" style={{ background: "#f8f8f8" }}>
          <div className="row g-3">
            <div className="col-lg-4 col-md-6 col-12">
              <input
                type="text"
                placeholder="Search products..."
                className="form-control"
                value={search}
                onChange={e => { setSearch(e.target.value); setCurrentPage(1); }}
              />
            </div>
            <div className="col-lg-4 col-md-6 col-12">
              <select
                className="form-select"
                value={selectedCategory}
                onChange={e => { setSelectedCategory(e.target.value); setCurrentPage(1); }}
              >
                {categories.map((cat,i) => <option key={i} value={cat}>{cat === 'all' ? 'All Categories' : cat}</option>)}
              </select>
            </div>
            <div className="col-lg-4 col-md-6 col-12">
              <select
                className="form-select"
                value={sortBy}
                onChange={e => setSortBy(e.target.value)}
              >
                <option value="default">Sort By</option>
                <option value="az">A → Z</option>
                <option value="za">Z → A</option>
                <option value="low-high">Price: Low → High</option>
                <option value="high-low">Price: High → Low</option>
              </select>
            </div>
          </div>
        </div>

        {/* Product Grid */}
        <div className="product-grid">
          {currentProducts.map(prod => {
            const inv = findInventory(prod.id);
            const compareP = inv?.compare_price ?? inv?.mrp;
            const priceP = inv?.price ?? inv?.selling_price;
            const mainImg = prod.productImage?.startsWith('http') ? prod.productImage : `${productImageBaseUrl}${prod.productImage}`;
            const hoverImg = prod.image2 ? (prod.image2.startsWith('http') ? prod.image2 : `${productImageBaseUrl}${prod.image2}`) : mainImg;
            const discountPercent = compareP && priceP ? Math.round(((compareP-priceP)/compareP)*100) : null;

            return (
              <div className="product-card" key={prod.id}>
                {prod.isBestseller && <div className="bestseller-tag">Bestseller</div>}
                {discountPercent && <div className="discount-tag">-{discountPercent}%</div>}

                <div className="product-card-img">
                  <img src={mainImg} className="main-img" alt={prod.productName} />
                  <img src={hoverImg} className="hover-img" alt={prod.productName} />
                  <div className="card-atc-bar">
                    <Link to={`/productdetails/${prod.id}`} className="w-50">
                      <button className="card-btn">ADD TO CART</button>
                    </Link>
                    <Link to={`/productdetails/${prod.id}`} className="w-50">
                      <button className="card-btn buy-btn">BUY NOW</button>
                    </Link>
                  </div>
                </div>

                <h3 className="product-card-title">{prod.productName}</h3>
                <div className="product-card-price">
                  {compareP && <del>{formatPrice(compareP)}</del>}
                  <ins>{formatPrice(priceP)}</ins>
                </div>
                <div className="product-rating">★★★★★ ({prod.reviewsCount || 0})</div>
              </div>
            );
          })}
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button className={`page-btn ${currentPage === 1 ? 'disabled-btn':''}`} onClick={()=>setCurrentPage(p=>Math.max(p-1,1))}>Previous</button>
          <button className={`page-btn ${currentPage === totalPages ? 'disabled-btn':''}`} onClick={()=>setCurrentPage(p=>Math.min(p+1,totalPages))}>Next</button>
        </div>
      </div>
    </>
  );
};

export default Product;
